export const EWORK_PLUS_LINKS: Record<string, Record<string, string>> = {
  Community: {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/community#",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/community#",
    NOR: "https://www.eworkgroup.com/no/eworkplus/tag/community#",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/community#",
    POL: "https://www.eworkgroup.com/pl/eworkplus-portal",
    default: "https://www.eworkgroup.com/eworkplus/tag/community#",
  },
  "Finance & Insurance": {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/finance-insurance#",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/finance-insurance#",
    NOR: "https://www.eworkgroup.com/no/eworkplus-portal",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/finance-insurance#",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/finance-insurance",
    default: "https://www.eworkgroup.com/eworkplus/tag/finance-insurance#",
  },
  "Guides & Resources": {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/guides-resources#",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/guides-resources#",
    NOR: "https://www.eworkgroup.com/no/eworkplus/tag/guides-resources#",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/guides-resources#",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/guides-resources",
    default: "https://www.eworkgroup.com/eworkplus/tag/guides-resources#",
  },
  "Market Insights": {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/market-insights#",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/market-insights#",
    NOR: "https://www.eworkgroup.com/no/eworkplus/tag/market-insights",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/market-insights",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/market-insights",
    default: "https://www.eworkgroup.com/eworkplus/tag/market-insights",
  },
  "Office & Lifestyle": {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/office-lifestyle#Anchor",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/office-lifestyle#Anchor",
    NOR: "https://www.eworkgroup.com/no/eworkplus/tag/office-lifestyle#Anchor",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/office-lifestyle#Anchor",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/office-lifestyle#Anchor",
    default: "https://www.eworkgroup.com/eworkplus/tag/office-lifestyle#Anchor",
  },
  "Travel & Accommodation": {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/travel-accommodation#",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/travel-accommodation#",
    NOR: "https://www.eworkgroup.com/no/eworkplus/tag/travel-accommodation",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/travel-accommodation",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/travel-accommodation",
    default: "https://www.eworkgroup.com/eworkplus/tag/travel-accommodation",
  },
  "Training & Certification": {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/training-certification#",
    DNK: "https://www.eworkgroup.com/da/eworkplus/tag/training-certification#",
    NOR: "https://www.eworkgroup.com/no/eworkplus/tag/training-certification",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/training-certification",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/training-certification",
    default: "https://www.eworkgroup.com/eworkplus/tag/training-certification",
  },
  Wellness: {
    SWE: "https://www.eworkgroup.com/sv/eworkplus/tag/wellness#",
    FIN: "https://www.eworkgroup.com/fi/eworkplus/tag/wellness#",
    POL: "https://www.eworkgroup.com/pl/eworkplus/tag/health#",
    default: "https://www.eworkgroup.com/eworkplus/tag/wellness#",
  },
};
